
$(document).ready(function(){
  console.log("index page here");
  init_home_sliders();

  
});


function init_home_sliders(){
    $(".slick-with-products").each(function() {
        console.log(($(this).find('.five_it_grid')).length);
        if(($(this).find('.five_it_grid')).length > 5){
            $(this).slick({
                dots: false,
                infinite: false,
                autoplay: true,
                speed: 500,
                slidesToShow: 5,
                slidesToScroll: 1,
                prevArrow:'<button type="button" class="slick-prev-custom"><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none"><rect x="-0.5" y="0.5" width="33" height="33" rx="16.5" transform="matrix(-1 0 0 1 33 0)" stroke="#1C1C1C"></rect><path d="M25.5 16.9995L10.0456 16.9995" stroke="#1C1C1C" stroke-width="1.5" stroke-linecap="square"></path><path d="M15.5793 9.92041L8.49993 16.9998L15.5793 24.0792" stroke="#1C1C1C" stroke-width="1.5" stroke-linecap="square"></path></svg></button>',
            nextArrow:'<button type="button" class="slick-next-custom"><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none"><rect x="0.5" y="0.5" width="33" height="33" rx="16.5" stroke="#1C1C1C"></rect><path d="M8.5 16.9995L23.9544 16.9995" stroke="#1C1C1C" stroke-width="1.5" stroke-linecap="square"></path><path d="M18.4207 9.92041L25.5001 16.9998L18.4207 24.0792" stroke="#1C1C1C" stroke-width="1.5" stroke-linecap="square"></path></svg></button>',
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                  }
                }
              ]
              });
        }
    });
}
